import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import React from "react";
var __jsx = React.createElement;
import { useState, useEffect } from "react";
import stl from "./Pagination.module.css";
import useHelpers from "@hooks/useHelpers";
import { CDN_LINK } from "@globalConfig";
var Pagination = function Pagination(_ref) {
  var pageCount = _ref.pageCount,
    currentPage = _ref.currentPage;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var _useState = useState(+currentPage),
    activePage = _useState[0],
    setActivePage = _useState[1];
  // 2 : number of pages to show
  var _useState2 = useState(_toConsumableArray(Array(pageCount)).map(function (_, i) {
      return i + 1;
    }).splice(currentPage - 1, 2)),
    pagesToShow = _useState2[0],
    setPagesToShow = _useState2[1];
  var arrayOfPages = _toConsumableArray(Array(pageCount)).map(function (_, i) {
    return i + 1;
  });
  useEffect(function () {
    var activePageIndex = pagesToShow.indexOf(activePage);
    if (activePageIndex >= pagesToShow.length - 2) {
      var arrayOfPagesCopy = _toConsumableArray(arrayOfPages);
      setPagesToShow(arrayOfPagesCopy.splice(activePage - 1, 2));
    }
  }, [activePage]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(stl.pagination, " ").concat(stl.trendingContainer)
  }, /*#__PURE__*/React.createElement("a", {
    className: [stl.prev, stl.trendingPrev, currentPage === 1 ? stl.disabled : ""].join(" "),
    disabled: currentPage === 1,
    href: createUrl(currentPage === 1 || currentPage === 2 ? "/trend" : "/trend?page=".concat(currentPage - 1))
  }, /*#__PURE__*/React.createElement("img", {
    src: currentPage === 1 ? CDN_LINK + "/assets/images/pagination/disabled_arrow.svg" : CDN_LINK + "/assets/images/pagination/arrow.svg",
    loading: "lazy",
    alt: "arrow",
    width: 24,
    height: 24
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.pagesNumContainer
  }, activePage >= pageCount - 2 && pageCount - 3 > 0 && /*#__PURE__*/React.createElement("a", {
    className: "\n               ".concat(stl.pagesNum, "\n              "),
    href: createUrl("/trend")
  }, "1"), activePage >= pageCount - 2 && pageCount - 3 > 0 && /*#__PURE__*/React.createElement("button", {
    className: stl.pagesNum
  }, "..."), activePage >= pageCount - 1 && pageCount - 2 > 0 && /*#__PURE__*/React.createElement("a", {
    className: "\n               ".concat(stl.pagesNum, "\n              "),
    href: createUrl("/trend?page=".concat(pageCount - 2))
  }, pageCount - 2), activePage === pageCount && pageCount - 1 > 0 && /*#__PURE__*/React.createElement("a", {
    className: "\n               ".concat(stl.pagesNum, "\n              "),
    href: createUrl(activePage - 1 == 1 ? "/trend" : "/trend?page=".concat(activePage - 1))
  }, activePage - 1), pagesToShow.filter(function (item) {
    return item !== pageCount;
  }).map(function (item) {
    return /*#__PURE__*/React.createElement("a", {
      key: item,
      className: "".concat(activePage === item ? stl.activeTrending : "", " ").concat(stl.pagesNum),
      href: createUrl("/trend".concat(item !== 1 ? "?page=".concat(item) : ""))
    }, item);
  }), activePage < pageCount - 3 && /*#__PURE__*/React.createElement("button", {
    className: "\n           ".concat(stl.pagesNum, "\n          ")
  }, "..."), /*#__PURE__*/React.createElement("a", {
    className: "\n           ".concat(activePage === pageCount ? stl.activeTrending : "", " ").concat(stl.pagesNum, "\n          "),
    href: createUrl("/trend?page=".concat(pageCount))
  }, pageCount)), /*#__PURE__*/React.createElement("a", {
    className: [stl.next, stl.trendingNext, currentPage === pageCount ? stl.disabled : ""].join(" "),
    disabled: currentPage === pageCount,
    href: createUrl("/trend?page=".concat(currentPage + 1))
  }, /*#__PURE__*/React.createElement("img", {
    src: currentPage === pageCount ? CDN_LINK + "/assets/images/pagination/disabled_arrow.svg" : CDN_LINK + "/assets/images/pagination/arrow.svg",
    alt: "arrow",
    loading: "lazy",
    width: 24,
    height: 24
  })));
};
export default Pagination;